<template>
    <!-- Fondo de marca de todo el sitio (el mismo del formulario nuevo): blanco
         con cuadrícula suave y tres manchas violeta / magenta / naranja que se
         mueven lento. Va FIJO detrás del contenido: cubre cualquier página, de
         cualquier alto, sin recalcular nada.

         Lo monta DefaultLayout en todas las rutas, salvo las que tengan
         `meta: { fondo: false }` (la portada). Una página nueva lo tiene sin
         hacer nada: solo hace falta que su contenedor no pinte un fondo blanco
         propio encima (usar transparente o tarjetas). -->
    <div :class="['hyf-fondo', { 'hyf-fondo--local': local }]" aria-hidden="true">
        <span class="hyf-fondo__blob hyf-fondo__blob--1"></span>
        <span class="hyf-fondo__blob hyf-fondo__blob--2"></span>
        <span class="hyf-fondo__blob hyf-fondo__blob--3"></span>
    </div>
</template>

<script>
export default {
    name: 'HyFFondo',
    props: {
        // local: dentro de un contenedor que tapa toda la pantalla (p. ej. la
        // calculadora, que es una capa fija). El contenedor necesita
        // `isolation: isolate` (o position + z-index) para que el fondo quede
        // detrás de su contenido y no detrás de la página.
        local: { type: Boolean, default: false },
    },
};
</script>

<style scoped>
.hyf-fondo {
    position: fixed;
    inset: 0;
    /* -1: detrás de todo el contenido sin envolverlo en otra capa (un z-index en
       el contenido dejaría modales y menús atrapados debajo del header). Se
       pinta sobre el fondo del body, que es blanco. */
    z-index: -1;
    overflow: hidden;
    pointer-events: none;
    background: #fff;
}
.hyf-fondo--local { position: absolute; }

/* Cuadrícula de 32 px, apenas marcada en los bordes y limpia en el centro */
.hyf-fondo::before {
    content: '';
    position: absolute;
    inset: 0;
    background:
        repeating-linear-gradient(0deg,  rgba(8, 11, 15, .04) 0 1px, transparent 1px 32px),
        repeating-linear-gradient(90deg, rgba(8, 11, 15, .04) 0 1px, transparent 1px 32px);
    -webkit-mask-image: radial-gradient(75% 75% at 50% 50%, transparent 35%, #000 100%);
            mask-image: radial-gradient(75% 75% at 50% 50%, transparent 35%, #000 100%);
}

.hyf-fondo__blob {
    position: absolute;
    width: 46vmax;
    height: 46vmax;
    border-radius: 50%;
    filter: blur(70px);
    opacity: .65;
    will-change: transform;
    animation: hyf-fondo-float 26s ease-in-out infinite alternate;
}
.hyf-fondo__blob--1 { top: -18vmax; left: 18vw; background: radial-gradient(circle, rgba(109, 60, 224, .55), rgba(109, 60, 224, 0) 68%); }
.hyf-fondo__blob--2 { top: 10vmax; right: -16vmax; background: radial-gradient(circle, rgba(184, 57, 159, .48), rgba(184, 57, 159, 0) 68%); animation-duration: 32s; animation-delay: -9s; }
.hyf-fondo__blob--3 { bottom: -20vmax; left: 40vw; background: radial-gradient(circle, rgba(242, 104, 31, .55), rgba(242, 104, 31, 0) 68%); animation-duration: 22s; animation-delay: -15s; }

@keyframes hyf-fondo-float {
    from { transform: translate3d(0, 0, 0) scale(1); }
    50%  { transform: translate3d(4vw, -3vh, 0) scale(1.08); }
    to   { transform: translate3d(-3vw, 4vh, 0) scale(.96); }
}

@media (prefers-reduced-motion: reduce) {
    .hyf-fondo__blob { animation: none; }
}

/* Al imprimir no se pinta */
@media print {
    .hyf-fondo { display: none; }
}
</style>
